import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import cn from '@/utils/cn';
import { railItemClass } from './railClasses';

export interface NavSection {
  // The section at the page's own path; it is current only on an exact match, so nested section
  // routes don't light it up too.
  index?: boolean;
  label: string;
  // Unset while the section is still on a legacy form: shown, but not a link.
  to?: string;
}

interface SectionNavProps {
  label: string;
  sections: NavSection[];
}

// An edit page's section list: one section shows at a time.
const SectionNav = ({ label, sections }: SectionNavProps) => {
  const { pathname } = useLocation();

  return (
    <nav aria-label={label} className="tw-flex tw-w-56 tw-shrink-0 tw-flex-col tw-gap-0.5">
      {sections.map((section) => {
        if (section.to === undefined) {
          return (
            <span
              key={section.label}
              aria-disabled="true"
              className={cn(railItemClass(false), 'tw-text-spa-tertiary hover:tw-bg-transparent')}
            >
              {section.label}
            </span>
          );
        }

        // A section with its own sub-routes (the resources dialogs) stays current under them.
        const active = pathname === section.to || (!section.index && pathname.startsWith(`${section.to}/`));
        return (
          <Link
            key={section.label}
            aria-current={active ? 'page' : undefined}
            className={railItemClass(active)}
            to={section.to}
          >
            {section.label}
          </Link>
        );
      })}
    </nav>
  );
};

export default SectionNav;
